
import { useSelector } from "react-redux";
import { useEffect } from "react";
import useIntercom from "@/hook/useIntercom";
import { useNavigate,useLocation } from "react-router-dom";

export default function HelpCenter() {
  const {initService} = useIntercom()
  const navigate = useNavigate();
  const { user } = useSelector(state => state?.user);
  const {settings} = useSelector(state => state?.app);
  const location = useLocation();
  const getIntercomLanguage = () => {
    const language = settings?.language
    if(language === 'cn'){
      return 'zh'
    } else if(language === 'hk'){
      return 'zh-TW'
    } 
    return language
  }
  const bindEvent = () => {
    window.Intercom('update', {
      language_override: getIntercomLanguage(),
    })
    window.Intercom('show')
    if(location.pathname.includes('/helpcenter')){
      window.Intercom('onHide', () => {
        navigate(-1)
      })
    }
    setTimeout(() => {
      window.Intercom('onHide', () => {
        
      })
    },100)
  }
  useEffect(() => {
    if (!window.Intercom) {
      initService(()=>{
        bindEvent()
      })
    }else{
      bindEvent()
    }
  }, [user])
  return <></>
}